var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 120,
    viewBox: "0 0 11 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95021 112C3.7264 112 1.96726 113.86 2.00046 116.05C2.00046 118.274 3.85917 120.033 6.04978 120C8.27359 120 10.0327 118.141 9.99954 115.95C9.99954 113.727 8.14083 111.968 5.95021 112Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82812 102.633H5V101.504H6.82812V102.633ZM6.82812 93.2955H5V85.0868H6.82812V93.2955ZM6.82812 76.8781H5V68.6694H6.82812V76.8781ZM6.82812 60.4607H5V52.2521H6.82812V60.4607ZM6.82812 44.0434H5V35.8347H6.82812V44.0434ZM6.82812 27.626H5V19.4174H6.82812V27.626ZM6.82812 11.2087H5V3H6.82812V11.2087Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolExclamation);
export default __webpack_public_path__ + "static/media/SYMBOL_EXCLAMATION.bffa8c99fcfa4ab606eb96930d328532.svg";
export { ForwardRef as ReactComponent };